import React from "react";
import { BasicError, RefetchIndicator } from "../_Misc";
import { useHomeHub } from "../../services/backend";
import makeStyles from "@mui/styles/makeStyles";
import { Scroller } from "./Scroller";
import { PosterCard, PosterCardSkeletonRow } from "../Cards";
import { buildAssetUrl } from "../../utils";

interface Props {}
export const ContinueWatchingHub: React.FC<Props> = () => {
  const { data, error, isFetching, isLoading } = useHomeHub();
  const classes = useStyles();

  // if (!data && !error) return <Spinner />;
  if (error) return <BasicError error={error?.message} />;
  // if (!data) return <Spinner />;

  const continue_watching = data?.continue_watching;
  if (continue_watching?.length === 0) return <></>;

  const uid = "continue_watching" + (isLoading ? "_loading" : "");

  return (
    <div>
      <div style={{ display: "flex" }}></div>
      <Scroller title={"Continue Watching"} uid={uid} hideScrollButtons={isLoading}>
        {isLoading ? (
          <PosterCardSkeletonRow uid={uid} />
        ) : (
          <>
            {continue_watching?.map(({ library_item: item }) => {
              return (
                <div className={classes.wrapper} key={`HUB_CONTINUE_${item.id}`}>
                  <PosterCard
                    alt={"Poster"}
                    image_url={buildAssetUrl(
                      item.poster?.cloudinary_path || item.media?.cloudinary_path,
                      "f_auto,h_500,w_333"
                    )}
                    link={`/d/item/${item.id}-${item.slug ?? ""}`}
                    title={item.root}
                  />
                </div>
              );
            })}
          </>
        )}
      </Scroller>
      {<RefetchIndicator visible={!isLoading && isFetching} />}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: { marginRight: theme.spacing(4) },
}));
